<template>
  <v-app>
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <v-list-tile to="/">
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--        <v-list-tile to="/sponsors">-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title>Sponsors</v-list-tile-title>-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <v-list-group
          v-for="(item, i) in seasons"
          :key="i"
          v-model="item.visible"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="`/${item.season_id}/${item.name.replace(' ', '-')}/standings`"
          >
            <v-list-tile-content>
              <v-list-tile-title
                >Points - {{ item.weeks_for_points }} weeks</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="`/${item.season_id}/${item.name.replace(' ', '-')}/top10`"
          >
            <v-list-tile-content>
              <v-list-tile-title
                >Top Avg - {{ item.weeks_for_average }} weeks</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="`/${item.season_id}/${item.name.replace(' ', '-')}/weeks`"
          >
            <v-list-tile-content>
              <v-list-tile-title>Weeks</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="item.track_hole_scores"
            :to="`/${item.season_id}/${item.name.replace(' ', '-')}/holes`"
          >
            <v-list-tile-content>
              <v-list-tile-title>Hole Stats</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-group v-model="adminVisible">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="!userIsLoggedIn"
            @click.stop="$authService.login()"
          >
            <v-list-tile-content>
              <v-list-tile-title>Login</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="userIsLoggedIn" :to="`/admin/rounds/new`">
            <v-list-tile-content>
              <v-list-tile-title
                ><v-icon>add</v-icon> New Round</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="userIsLoggedIn" :to="`/admin/rounds`">
            <v-list-tile-content>
              <v-list-tile-title>Rounds</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="userIsLoggedIn" :to="`/admin/players`">
            <v-list-tile-content>
              <v-list-tile-title>Players</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="userIsLoggedIn" :to="`/admin/seasons`">
            <v-list-tile-content>
              <v-list-tile-title>Seasons</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-spacer></v-spacer>
          <v-list-tile
            v-if="userIsLoggedIn"
            @click.stop="$authService.logout()"
          >
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dark fixed app class="pl-0 ml-0">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Kentwood Summer Doubles</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      drawer: this.$vuetify.breakpoint.lgAndUp,
      userIsLoggedIn: false,
      adminVisible: false,
      seasons: [],
    };
  },
  methods: {
    showSelected() {
      if (
        !this.$route.params.seasonId ||
        this.$route.fullPath.indexOf("admin") > -1
      )
        return;

      this.seasons.forEach((season) => {
        season.visible =
          season.season_id.toString() ===
          this.$route.params.seasonId.toString();
      });
    },
    handleAdminMenu() {
      this.userIsLoggedIn = this.$authService.isAuthenticated();
      this.adminVisible = this.userIsLoggedIn;
    },
    async fetchData() {
      const result = await this.$apiClient.seasons();

      this.seasons = result.data.filter((s) => s.active);
      this.seasons[0].visible = true;
      this.showSelected();
    },
  },
  created() {
    this.fetchData();
    this.$authService.authNotifier.on("authChange", () => {
      this.handleAdminMenu();
    });
    this.handleAdminMenu();
  },
  destroyed() {
    this.$authService.authNotifier.off("authChange");
  },
  watch: {
    $route: "showSelected",
  },
};
</script>

<style lang="scss">
/*import 'iview/dist/styles/iview.css';*/

.rollup-cell-sm {
  width: 50px !important;
}
.rollup-cell-md {
  width: 75px !important;
}
.table td.player-name,
.table th.player-name {
  min-width: 200px;
}
.player:not(:first-child):before {
  padding-left: 5px;
  content: " / ";
}
.player {
  display: inline-block;
  break-inside: avoid-column;
}
section {
  margin-bottom: 25px;
}

@media print {
  section.division {
    page-break-after: always;
  }
  .weeks-list {
    display: none;
  }
  table.table-sm {
    font-size: 0.5rem;
  }
}
</style>
